import { createReduxStore } from '#packages/apilib';

interface AnimationsState {
  isInScrubPreview: boolean;
}

const getInitialState = (): AnimationsState => ({
  isInScrubPreview: false,
});

export const AnimationsStore = createReduxStore({
  getInitialState,
  selectors: {
    getIsInScrubPreview: (state) => state.isInScrubPreview,
  },
  actions: {
    setIsInScrubPreview: (
      state: AnimationsState,
      isInScrubPreview: boolean,
    ) => ({
      ...state,
      isInScrubPreview,
    }),
  },
});
